module.exports = __webpack_public_path__ + "static/img/right-radius.377f49b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/right-radius.png
// module id = X6mT
// module chunks = 0